import React from 'react';
import { Tooltip } from './Tooltip';
import { getKeywordDefinition } from '../../data/keywordDefinitions';

interface DamageTypeBadgeProps {
  damageType: string;
  className?: string;
  showTooltip?: boolean;
}

const damageTypeIcons: Record<string, string> = {
  physical: '⚔️',
  magical: '✨',
  fire: '🔥',
  lightning: '⚡',
  ice: '❄️',
  water: '💧',
  poison: '☠️',
  piercing: '🗡️',
  enchanted: '✨',
  will: '🧠'
};

export const DamageTypeBadge: React.FC<DamageTypeBadgeProps> = ({
  damageType,
  className = '',
  showTooltip = true
}) => {
  if (!damageType) {
    return null;
  }

  const definition = getKeywordDefinition(damageType);
  const icon = damageTypeIcons[damageType.toLowerCase()] || '⚔️';
  
  const badge = (
    <span
      className={`damage-type-badge damage-type-${damageType} ${className}`}
      style={{
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.85em',
        fontWeight: 'bold',
        marginLeft: '4px',
        cursor: definition && showTooltip ? 'help' : 'default',
        textDecoration: definition && showTooltip ? 'underline dotted' : 'none',
        textDecorationColor: definition && showTooltip ? 'rgba(255, 255, 255, 0.5)' : 'transparent'
      }}
    >
      {icon} {damageType}
    </span>
  );

  if (showTooltip && definition && definition.description) {
    return (
      <Tooltip content={definition.description} position="top">
        {badge}
      </Tooltip>
    );
  }

  return badge;
};
